import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateTestimonial } from "../../api/apiTestimonials";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

export function useUpdateTestimonial() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: updateItemMutate, isPending } = useMutation({
        mutationFn: ({ id, data }) => updateTestimonial(id, data),
        onSuccess: (response) => {
            toast.success(response.message || "Updated successfully");
            queryClient.invalidateQueries({ queryKey: ["testimonials"] });
            navigate("/testimonials");
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update testimonial");
        },
    });

    return { updateItemMutate, isPending };
}
